class PredictiveSearch {
  constructor() {
    this.searchInput = document.querySelector('.search-input');
    this.searchResults = document.getElementById('search-results');
    this.searchResultsList = document.getElementById('search-results-list');
    this.searchForm = document.querySelector('.search-form');
    
    if (this.searchInput && this.searchResults && this.searchResultsList) {
      this.init();
    }
  }
  
  init() {
    let searchTimeout;
    
    this.searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      
      clearTimeout(searchTimeout);
      
      if (query.length < 2) {
        this.hideResults();
        return;
      }
      
      searchTimeout = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    });
    
    // Hide results when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.search-container')) {
        this.hideResults();
      }
    });
    
    // Prevent form submission when results are shown
    if (this.searchForm) {
      this.searchForm.addEventListener('submit', (e) => {
        if (this.searchResults.style.display !== 'none') {
          this.hideResults();
        }
      });
    }
  }
  
  async performSearch(query) {
    try {
      const searchUrl = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`;
      
      const response = await fetch(searchUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
        this.displayResults(data.resources.results.products, query);
      } else {
        this.displayNoResults();
      }
    } catch (error) {
      console.error('Search error:', error);
      this.displayNoResults();
    }
  }
  
  displayResults(products, query) {
    this.searchResultsList.innerHTML = '';
    
    products.forEach(product => {
      const resultItem = document.createElement('a');
      resultItem.href = product.url;
      resultItem.className = 'search-result-item';
      
      const image = product.featured_image ? 
        `<img src="${product.featured_image.url}" alt="${product.featured_image.alt}" class="search-result-image">` :
        `<div class="search-result-image" style="background: var(--color-background-secondary); display: flex; align-items: center; justify-content: center; color: var(--color-foreground); opacity: 0.5;">No image</div>`;
      
      // Get category/collection info - try multiple fields
      let category = '';
      if (product.product_type && product.product_type !== '') {
        category = product.product_type;
      } else if (product.type && product.type !== '') {
        category = product.type;
      } else if (product.vendor && product.vendor !== '') {
        category = product.vendor;
      } else if (product.tags && product.tags.length > 0) {
        category = product.tags[0];
      }
      
      const categoryHtml = category ? `<div class="search-result-category">${this.escapeHtml(category)}</div>` : '';
      
      resultItem.innerHTML = `
        ${image}
        <div class="search-result-info">
          ${categoryHtml}
          <div class="search-result-title">${this.highlightMatch(product.title, query)}</div>
          <div class="search-result-price">${product.price}</div>
        </div>
      `;
      
      this.searchResultsList.appendChild(resultItem);
    });
    
    this.showResults();
  }
  
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  displayNoResults() {
    this.searchResultsList.innerHTML = '<div class="search-result-item">Keine Produkte gefunden</div>';
    this.showResults();
  }
  
  highlightMatch(text, query) {
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  }
  
  showResults() {
    this.searchResults.style.display = 'block';
  }
  
  hideResults() {
    this.searchResults.style.display = 'none';
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new PredictiveSearch();
});
